import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import type { DenormalizedBlockEntity } from '@web/types';

import { SpSafeHtmlPipe } from '@common/pipes/safe-html.pipe';

import type { ShapeDividerSlot } from './block-shape-dividers.model';
import { getShapeDividerSlots } from './block-shape-dividers.model';

@Component({
    selector: 'web-block-shape-dividers',
    templateUrl: './block-shape-dividers.component.html',
    styleUrls: ['./block-shape-dividers.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SpSafeHtmlPipe],
})
export class BlockShapeDividers {
    public readonly entity = input.required<DenormalizedBlockEntity>();

    /**
     * Every edge that is switched on, at every breakpoint; which one shows is a
     * `@container` decision, so the editor's device preview needs no input here.
     */
    public readonly dividers = computed<ShapeDividerSlot[]>(() => getShapeDividerSlots(this.entity() as never));
}
